// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.radio-button:hover input ~ .checkmark {
  background-color: #ebebec;
}
.radio-button.opacity-50:hover input ~ .checkmark {
  background-color: #fafafa !important;
}
.radio-button input:checked ~ .checkmark {
  background-color: rgb(var(--color-primary));
}
.checkmark:after {
  content: "";
  position: absolute;
  display: none;
}
.radio-button input:checked ~ .checkmark:after {
  display: block;
}
.radio-button .checkmark:after {
  left: 6px;
  top: 3px;
  width: 5px;
  height: 8px;
  border: solid white;
  border-width: 0 2px 2px 0;
  transform: rotate(45deg);
}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
